import { all, takeLatest } from 'redux-saga/effects'
import store from '../../../store'
import { actions } from './StandaloneCases.slice'
import { paginate } from './StandaloneCases.thunk'

function paginateCases () {
  store.dispatch(paginate() as any)
}

export default function * effects () {
  yield all([
    takeLatest(actions.replaceLimit, paginateCases),
    takeLatest(actions.replacePage, paginateCases),
    takeLatest(actions.replaceSearch, paginateCases)
  ])
}
